








































































import {Component, Mixins} from 'vue-property-decorator'
import {$, IResource} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import FilterDelivery from '@/components/filters/FilterDelivery.vue'
import ModalDeliveryDriverAssociation from '@/components/modals/ModalDeliveryDriverAssociation.vue'
import DeliveryRequest from '@/model/request/DeliveryRequest'
import CargaCollection from '@/model/collection/CargaCollection'
import Carga from '@/model/resource/Carga'
import {DeliveryDriverStatus} from '@/enums/DeliveryDriverStatus'
import ItDriverAssociationCsvUpload from '@/components/itrack/ItDriverAssociationCsvUpload.vue'
import FilterToggle from '@/components/FilterToggle.vue'

const metaInfo = () => ({
  title: $.t('view.manage.deliveryDriver.title'),
})

@Component({
  metaInfo,
  components: {FilterToggle, ItDriverAssociationCsvUpload, FilterDelivery, ModalDeliveryDriverAssociation},
})
export default class ManageDeliveryDriverView extends Mixins(MixinFilter, MixinSelect) {
  AppConfig = AppConfig

  filter = new DeliveryRequest()
  collection = new CargaCollection(this.filter)

  selectedItems: Carga[] = []

  openModalDeliveryDriverAssociation(items?: Carga[]) {
    const selectedItems = items || this.selectedItems
    this.$modal.open('deliveryDriverAssociation', selectedItems)
  }

  async refresh() {
    this.selectedResource = {}
    this.selectedItems = []
    await this.collection.setCurrentPage(0)
  }

  created() {
    if (this.$route.query.start === undefined) {
      this.filter.startDate = DeliveryRequest.defaultStartOfDay()
    }

    this.filter.status = `${DeliveryStatus.PENDING}`
    this.filter.driverStatus = DeliveryDriverStatus.WITHOUT_DRIVER

    this.collection.orderBy = 'dataCriacao'
    this.collection.asc = false
  }
}
